/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/
import * as React from 'react';
import { createComponent } from '@lit/react';
import type { EventName } from '@lit/react';
import { ActionButton as SpActionButton } from '@spectrum-web-components/action-button';

import '@spectrum-web-components/action-button/sp-action-button.js';

export const ActionButton = createComponent({
    displayName: 'ActionButton',
    elementClass: SpActionButton,
    react: React,
    tagName: 'sp-action-button',
    events: {
        longpress: 'longpress' as EventName<CustomEvent>, // Synthesizes a "longpress" interaction that signifies a `pointerdown` event that is >=300ms or a keyboard event where code is `Space` or code is `ArrowDown` while `altKey===true`.
        change: 'change' as EventName<Event>, // Announces a change in the `selected` property of an action button
    },
});

export type ActionButtonType = EventTarget & SpActionButton;
